import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { StudentBookingErrorResponse } from 'src/api/types';
import {
    getIsValidRebooker,
    IsValidRebookerResponse,
    RebookersEndpoints,
} from 'src/api/rebookersService';

import { queryRetry } from '../query-retry';

export const useGetIsValidRebooker = (
    roomCode: string,
    enabled: boolean,
    config?: UseQueryOptions<IsValidRebookerResponse, AxiosError<StudentBookingErrorResponse>>
) =>
    useQuery<IsValidRebookerResponse, AxiosError<StudentBookingErrorResponse>>({
        ...config,
        enabled: enabled && !!roomCode,
        queryKey: [RebookersEndpoints.GetIsValidRebooker, roomCode],
        queryFn: () => getIsValidRebooker(roomCode),
        retry: queryRetry,
    });
